import React from 'react';

import {
  HeaderDesktopContent,
  HeaderTitle,
  HeaderDesktopWrapper,
  HeaderDesktopContainer,
  ButtonLink,
  ButtonsContainer,
  LeftButtonsContainer,
  IconWrapper,
} from './styles';
import Menu from '../Menu';
import Icon from '../../../../assets/icons';
import { useLocation } from 'react-router-dom';

const HeaderDesktop = () => {
  const location = useLocation();
  const isTournamentsPage = location.pathname.startsWith('/tournaments');

  return (
    <HeaderDesktopWrapper>
      <HeaderDesktopContainer>
        <ButtonsContainer>
          <ButtonLink href='https://timer.usnexpert.com/' target='_blank'>
            TIMER
          </ButtonLink>
          <ButtonLink href='/'>BANK OF CASES</ButtonLink>
          <ButtonLink href='/tournaments'>OUR TOURNAMENTS</ButtonLink>
        </ButtonsContainer>
        <HeaderDesktopContent>
          <IconWrapper>
            <Icon variant='logo' />
          </IconWrapper>
          <HeaderTitle>Universal School of Negotiation</HeaderTitle>
        </HeaderDesktopContent>
        <LeftButtonsContainer>
          <ButtonLink href='/'>COURSES</ButtonLink>
          <ButtonLink href='/'>TRAININGS</ButtonLink>
        </LeftButtonsContainer>
      </HeaderDesktopContainer>
      {!isTournamentsPage && <Menu />}
    </HeaderDesktopWrapper>
  );
};

export default HeaderDesktop;
